import axios from "axios";
import React, { Component } from "react";
import cookie from "react-cookies";
import {
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
} from "reactstrap"; // Assuming some reactstrap components might be useful for the OTP part
import constants from "../Constants"; // Adjust path as necessary
import { QIKTRUCK_PRIVACY_URL } from "../constants/legal";

const baseURL = constants.baseURL;

class SignUpForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      apierror: "",
      email: "",
      message: "",
      otp: "",
      showOtpField: false,
      id: null, // To store the id from getcustomerOTP response
    };
  }

  isLoginMode() {
    return this.props.mode === "login";
  }

  redirectAfterAuth() {
    const params = new URLSearchParams(window.location.search);
    const redirect = params.get("redirect") || params.get("returnTo");
    if (redirect && redirect.startsWith("/") && !redirect.startsWith("//")) {
      return redirect;
    }
    return "/dashboard";
  }

  trackCompletedRegistration() {
    if (this.isLoginMode() || typeof window.fbq !== "function") {
      return;
    }

    window.fbq("track", "CompleteRegistration", {
      content_name: "QikTruck Business account",
      status: true,
    });
  }

  validEmail() {
    const { email } = this.state;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return email !== "" && emailRegex.test(email);
  }

  validOtp() {
    const { otp } = this.state;
    // Basic OTP validation (e.g., numbers and characters, or just not empty)
    const otpRegex = /^[0-9a-zA-Z]{4,}$/; // Example: at least 4 alphanumeric characters
    return otp !== "" && otpRegex.test(otp);
  }

  handleEmailSubmit = () => {
    const { email } = this.state;
    this.setState({ loading: true, apierror: "" });
    axios
      .post(baseURL + "/customer-otp", { email }) // Assuming the same endpoint for signup OTP
      .then((response) => {
        this.setState({
          loading: false,
          showOtpField: true,
          id: response.data.id, // Capture ID for OTP validation
          message: response.data.message || "", // Show any message from API
        });
      })
      .catch((e) => {
        console.error(e);
        this.setState({
          loading: false,
          apierror: "Failed to send OTP. Please check your email or try again.",
        });
      });
  };

  handleOtpSubmit = () => {
    const { email, otp, id } = this.state;
    this.setState({ loading: true, apierror: "" });
    axios
      .post(baseURL + "/validate-customer-otp", {
        // Assuming the same endpoint for OTP validation
        email,
        otp,
        id,
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.message && response.data.message.length > 0) {
            this.setState({
              loading: false,
              message: response.data.message,
              // Potentially reset showOtpField if OTP was wrong but user can retry
            });
          } else {
            // Successful validation / sign up
            // Save cookies as in the original login component
            cookie.save("session-id-qt", response.data["session-id-qt"], {
              path: "/",
              maxAge: 86400,
              secure: true, // Set to true in production
            });
            cookie.save("ctName", response.data.firstname, {
              path: "/",
              maxAge: 86400,
              secure: true,
            });
            cookie.save("localsessionid", response.data.customerid, {
              path: "/",
              maxAge: 86400,
              secure: true,
            });
            cookie.save("promocode", response.data.promocode, {
              path: "/",
              maxAge: 86400,
              secure: true,
            });
            this.trackCompletedRegistration();
            this.setState(
              {
                loading: false,
                apierror: "",
                message: this.isLoginMode()
                  ? "Signed in! Redirecting..."
                  : "Sign up successful! Redirecting...",
              },
              () => {
                const dest = this.redirectAfterAuth();
                setTimeout(() => (window.location.href = dest), this.isLoginMode() ? 400 : 2000);
              }
            );
          }
        }
      })
      .catch((e) => {
        console.error(e);
        this.setState({
          loading: false,
          apierror: "OTP validation failed. Please try again.",
        });
      });
  };

  renderEmailForm() {
    return (
      <div>
        <div className="qt-signup-row">
          <input
            type="email"
            placeholder="Email"
            style={{
              padding: "15px",
              marginRight: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              flexGrow: 1,
              fontSize: "16px",
            }}
            value={this.state.email}
            onChange={(e) => this.setState({ email: e.target.value })}
            disabled={this.state.loading}
          />
          <button
            style={{
              backgroundColor: "orange",
              color: "white",
              border: "none",
              padding: "15px 30px",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "16px",
              fontWeight: "bold",
            }}
            onClick={this.handleEmailSubmit}
            disabled={!this.validEmail() || this.state.loading}
          >
            {this.state.loading ? "Sending..." : this.isLoginMode() ? "Send sign-in code" : "Get Started"}
          </button>
        </div>
        {!this.validEmail() && this.state.email !== "" && (
          <p
            style={{
              fontSize: "12px",
              color: "red",
              marginTop: "-5px",
              marginBottom: "10px",
            }}
          >
            Please enter a valid email address.
          </p>
        )}
      </div>
    );
  }

  renderOtpForm() {
    return (
      <div className="login-form part-2">
        <p
          style={{ cursor: "pointer", color: "#4f6367", marginBottom: "15px" }}
          onClick={() =>
            this.setState({
              showOtpField: false,
              otp: "",
              apierror: "",
              message: "",
            })
          }
        >
          <i className="mdi mdi-arrow-left"></i> Change email or try again
        </p>
        <FormGroup>
          <Label for="otp" style={{ fontWeight: "bold" }}>
            Enter OTP sent to {this.state.email}
          </Label>
          <Input
            id="otp"
            name="otp"
            placeholder="One Time PIN"
            type="text" // Changed to text to allow alphanumeric, adjust if numeric only
            value={this.state.otp}
            onChange={(e) => this.setState({ otp: e.target.value })}
            invalid={this.state.otp !== "" && !this.validOtp()}
            style={{
              padding: "15px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              fontSize: "16px",
              marginBottom: "10px",
            }}
          />
          {this.state.otp !== "" && !this.validOtp() && (
            <div
              className="text-danger mt-1"
              style={{
                fontSize: "12px",
                color: "red",
                marginTop: "-5px",
                marginBottom: "10px",
              }}
            >
              Please enter a valid OTP.
            </div>
          )}
        </FormGroup>
        <button
          style={{
            backgroundColor: "#4f6367",
            color: "white",
            border: "none",
            padding: "15px 25px",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "16px",
            fontWeight: "bold",
          }}
          onClick={this.handleOtpSubmit}
          disabled={!this.validOtp() || this.state.loading}
        >
          {this.state.loading ? "Verifying..." : this.isLoginMode() ? "Sign in" : "Verify"}
        </button>
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        <Modal
          isOpen={
            !!this.state.message &&
            !this.state.message.toLowerCase().includes("redirecting")
          }
          size={"sm"}
          toggle={() => this.setState({ message: "" })}
        >
          <ModalBody>
            <Row>
              <Col sm={12}>
                <h5 className="text-center" style={{ padding: "20px" }}>
                  {this.state.message}
                </h5>
              </Col>
            </Row>
          </ModalBody>
        </Modal>

        {this.state.apierror && (
          <p
            style={{
              color: "red",
              fontSize: "14px",
              textAlign: "center",
              marginBottom: "10px",
            }}
          >
            {this.state.apierror}
          </p>
        )}

        {!this.state.showOtpField
          ? this.renderEmailForm()
          : this.renderOtpForm()}

        {this.state.message &&
          this.state.message.toLowerCase().includes("redirecting") && (
            <p
              style={{
                color: "green",
                fontSize: "14px",
                textAlign: "center",
                marginTop: "10px",
              }}
            >
              {this.state.message}
            </p>
          )}

        <p style={{ fontSize: "12px", color: "#777", marginTop: "15px" }}>
          {this.isLoginMode() ? (
            <>
              New to QikTruck Business?{" "}
              <a href="/" style={{ color: "#4f6367", fontWeight: 600 }}>
                Create an account
              </a>
              .
            </>
          ) : (
            <>
              By signing up, I acknowledge the{" "}
              <a
                href={QIKTRUCK_PRIVACY_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#4f6367" }}
              >
                QIKTRUCK Privacy Policy
              </a>
              .
            </>
          )}
        </p>
      </React.Fragment>
    );
  }
}

export default SignUpForm;
